import React from "react";

const imageStyle = {
  width: "100%",
  margin: "12px 0",
  borderRadius: "8px",
  border: "1px solid #ccc",
  cursor: "zoom-in"
};

const image = (src, alt) => (
  <img src={`/help/${src}`} alt={alt} style={imageStyle} />
);

export const FAQ_ITEMS = [
  {
    id: "create-client",
    question: "Hogyan hozzak létre új klienst?",
    answer: (
      <>
        <p>- A kezdőlapon kattints az "Új kliens" gombra.</p>
        {image("newClientButtonHU.png", "Új kliens létrehozása")}
        <p>- Kérlek töltsd ki a kliens adatait.</p>
        {image("newClientModalHU.png", "Új kliens létrehozása")}
        <p>- Kattints az "Kliens hozzáadása" gombra.</p>
      </>
    )
  },
  {
    id: "create-work",
    question: "Hogyan hozzak létre új munkát?",
    answer: (
      <>
        <p>
          - Nyisd meg a kliens adatait, viszont ha még nincs létre kell hoznod
          egyet.
        </p>
        <p>- Kattints az "Új munka" gombra.</p>
        {image("newWorkButtonHU.png", "Új munka létrehozása")}
        <p>- Add meg a munka nevét.</p>
        <p>- Kattints az "Új munka létrehozása" gombra.</p>
        {image("newWorkModalHU.png", "Új munka létrehozása")}
      </>
    )
  },
  {
    id: "add-items",
    question: "Hogyan adjak hozzá új méreteket egy munkához?",
    answer: (
      <>
        <p>- Nyisd meg a munkát. Ha nincs akkor hozz létre egyet.</p>
        {image("clickOnTheWorkHU.png", "Munka megnyitása")}
        <p>- Itt láthatók a kijelölt munka adatai.</p>
        <p>- Kattints a Méretek gombra.</p>
        {image("dimensionsButtonHU.png", "Méretek gomb")}
        <p>
          - Töltsd ki a szükséges mezőket majd pedig a darabszámnál nyomj
          ENTERt.
        </p>
        {image("dimensionsPageHU.png", "Mezők kitöltése")}
      </>
    )
  },
  {
    id: "dimensions",
    question: "Mit jelentenek a méret mezők (hossz, szélesség, vastagság)?",
    answer: (
      <>
        {image("dimensionsPageHU.png", "Mezők kitöltése")}
        <ul>
          <li>
            <p>
              Részletek - itt kell megjelölni ha duplung, rama vagy szögbevágás
              készül
            </p>
          </li>
          <li>
            <p>Hosszúság - ez a kívánt hosszúság (nem tartalmazza a kantot)</p>
          </li>
          <li>
            <p>
              Hossz. kant (db) - hányat kell kantolni hosszanti irányban (0, 1
              vagy 2 lehet)
            </p>
          </li>
          <li>
            <p>Szélesség - ez a kívánt szélesség (nem tartalmazza a kantot)</p>
          </li>
          <li>
            <p>
              Szél. kant (db) - hányat kell kantolni szélességi irányban (0, 1
              vagy 2 lehet)
            </p>
          </li>
          <li>
            <p>Db - ez a kívánt darabszám</p>
          </li>
          <li>
            <p>
              Kant - mindig ki kell jelölni, hogy milyen típusú élzárást
              szeretnénk (-, 04, 2 42, 1 lehet)
            </p>
          </li>
        </ul>
      </>
    )
  },
  {
    id: "modify-items",
    question: "Hogyan módosítsuk/töröljük a hozzáadott elemeket?",
    answer: (
      <>
        {image("modifyItemsHU.png", "Elemek módosítása")}
        <p>
          Az első oszlopban található négyzet segítségével jelölhetjük ki az
          elemeket. Ha a legfelső négyzetet jelöljük be, akkor az összes elem ki
          lesz jelölve.
        </p>
        <p>
          És a felső sorban lehet változtatni a kijelölt elemek adatait. Továbbá
          lehet menteni, vagy törölni a kijelölt elemeket.
        </p>
        <p>
          Van lehetőség a táblázaton belül is egyenként külön-külön is a
          módosításra.
        </p>
      </>
    )
  },
  {
    id: "generate",
    question: "Hogyan működik a tábla-generálás?",
    answer: (
      <>
        <p>
          A generálás során a rendszer optimalizálja az elemek elhelyezését.
        </p>
        <ol>
          <li>Legalább egy elem szükséges</li>
          <li>
            Kattints a <b>Generálás</b> gombra
          </li>
          <li>A rendszer több táblát is létrehozhat</li>
        </ol>
      </>
    )
  },
  {
    id: "waste",
    question: "Miért keletkezik hulladék, és hogyan csökkenthetem?",
    answer: (
      <>
        <p>
          Hulladék akkor keletkezik, ha az elemek nem töltenek ki teljes táblát.
        </p>
        <ul>
          <li>Használj forgatást</li>
          <li>Egységes méreteket</li>
          <li>Nagyobb táblákat</li>
        </ul>
      </>
    )
  },
  {
    id: "rotate-move",
    question: "Hogyan működik a forgatás és az áthelyezés?",
    answer: (
      <>
        <p>Szerkesztési módban az elemek kézzel mozgathatók.</p>
        <ul>
          <li>Forgatás csak ütközésmentesen engedélyezett</li>
          <li>Másik táblára csak azonos szín esetén helyezhető át</li>
        </ul>
      </>
    )
  },
  {
    id: "kant",
    question: "Mit jelent a kant, és hogyan számolja a rendszer?",
    answer: (
      <>
        <p>A kant az élzárást jelenti.</p>
        <ul>
          <li>Hosszanti és keresztkant külön számolódik</li>
          <li>A rendszer összesíti munka és tábla szinten</li>
        </ul>
      </>
    )
  },
  {
    id: "materials",
    question: "Hogyan kezeljem a különböző anyagokat és színeket?",
    answer: (
      <>
        <p>Minden szín külön anyagot jelent.</p>
        <ul>
          <li>Színenként külön optimalizálás történik</li>
          <li>Nem keverhetőek egy táblán</li>
        </ul>
      </>
    )
  },
  {
    id: "move-between",
    question: "Hogyan helyezhetek át elemet egyik tábláról a másikra?",
    answer: (
      <>
        <p>Áthelyezés csak azonos színű táblák között lehetséges.</p>
        <ol>
          <li>Válaszd ki az elemet</li>
          <li>
            Kattints az <b>Áthelyezés</b> gombra
          </li>
          <li>A rendszer szabad pozíciót keres</li>
        </ol>
      </>
    )
  },
  {
    id: "utilization",
    question: "Mit jelent a kihasználtság százalék?",
    answer: (
      <>
        <p>A kihasználtság megmutatja, mennyire van kitöltve a tábla.</p>
        <p>100% = nincs hulladék.</p>
      </>
    )
  },
  {
    id: "save-without-generate",
    question: "Hogyan mentsem el a módosításokat generálás nélkül?",
    answer: (
      <>
        <p>
          A <b>Mentés</b> gomb csak az aktuális módosításokat menti.
        </p>
        <p>Újragenerálás csak szükség esetén történik.</p>
      </>
    )
  },
  {
    id: "export",
    question: "Hogyan exportálhatom a táblákat PDF-be?",
    answer: (
      <ol>
        <li>
          Kattints az <b>Exportálás</b> gombra
        </li>
        <li>Válaszd ki az export típusát</li>
        <li>A rendszer PDF-et generál</li>
      </ol>
    )
  },
  {
    id: "closed-work",
    question: "Mi történik, ha a munkát lezárom?",
    answer: (
      <>
        <p>Lezárt munka nem szerkeszthető.</p>
        <p>Admin jogosultsággal újranyitható.</p>
      </>
    )
  },
  {
    id: "cost",
    question: "Hogyan számolja a rendszer a költségeket?",
    answer: (
      <ul>
        <li>Anyagköltség táblák alapján</li>
        <li>Vágáshossz</li>
        <li>Kant hossz</li>
      </ul>
    )
  },
  {
    id: "not-fit",
    question: "Mit tegyek, ha egy elem nem fér fel egyik táblára sem?",
    answer: (
      <>
        <p>Ellenőrizd a méreteket.</p>
        <p>Adj hozzá új táblát vagy módosítsd az anyagot.</p>
      </>
    )
  }
];
